export default __webpack_public_path__ + "static/media/Aff-Asset-Quote-gen-Shop-02102564.9c5ab23e.png";